<!-- Content Wrapper -->
<div class="wrapper wrapper-content">
  <!-- Import Section -->
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Import Purse Breakdown</h5>
        </div>
        <div class="ibox-content">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-2 control-label">XML Definition File:</label>
              <div class="col-sm-8">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Select purse breakdown XML file..."
                    [(ngModel)]="importFilePath"
                    name="importFilePath"
                  />
                  <span class="input-group-btn">
                    <button
                      type="button"
                      class="btn btn-primary"
                      (click)="onBrowseFile()"
                    >
                      <i class="fa fa-folder-open"></i> Browse
                    </button>
                  </span>
                </div>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="btn btn-success"
                  (click)="onImportFile()"
                  [disabled]="!importFilePath()"
                >
                  <i class="fa fa-upload"></i> Import
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content Row -->
  <div class="row">
    <!-- Settings Panel -->
    <div class="col-lg-3">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Purse Settings</h5>
        </div>
        <div class="ibox-content">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-5 control-label">Total Purse:</label>
              <div class="col-sm-7">
                <p class="form-control-static text-right text-navy">
                  {{ formatCurrency(purseSettings().totalPurse) }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-5 control-label">Admin Fee:</label>
              <div class="col-sm-7">
                <p class="form-control-static text-right text-navy">
                  {{ purseSettings().adminFee.toFixed(2) }}%
                </p>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-5 control-label">1st Place:</label>
              <div class="col-sm-7">
                <p class="form-control-static text-right text-navy">
                  {{ purseSettings().firstPlacePercentage.toFixed(2) }}%
                </p>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-5 control-label">Places to Pay:</label>
              <div class="col-sm-7">
                <p class="form-control-static text-right text-navy">
                  {{ purseSettings().placesToPay }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-5 control-label">Created On:</label>
              <div class="col-sm-7">
                <app-audit-info [dateUtc]="purseCreatedOnUtc() ?? undefined"></app-audit-info>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-5 control-label">Modified On:</label>
              <div class="col-sm-7">
                <app-audit-info [dateUtc]="purseModifiedOnUtc() ?? undefined"></app-audit-info>
              </div>
            </div>
          </form>

          <hr />

          <div class="purse-summary">
            <div class="summary-item">
              <span class="summary-label">Net Purse:</span>
              <span class="summary-value text-navy">{{
                formatCurrency(netPurse())
              }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">1st Place Prize:</span>
              <span class="summary-value text-success">{{
                formatCurrency(firstPlacePrize())
              }}</span>
            </div>
          </div>

          @if (purseTotalsWarning()) {
          <div class="alert alert-warning m-t-sm">
            <i class="fa fa-exclamation-triangle"></i>
            {{ purseTotalsWarning() }}
          </div>
          }

          <div class="text-center">
            <button
              type="button"
              class="btn btn-primary btn-block"
              (click)="onUpdateProjection()"
              [disabled]="isLoadingProjection()"
            >
              @if (isLoadingProjection()) {
              <i class="fa fa-spinner fa-spin"></i> Updating... } @else {
              <i class="fa fa-refresh"></i> Update Projection }
            </button>
            <button
              type="button"
              class="btn btn-success btn-block m-t-sm"
              (click)="onAssignToPlayers()"
              [disabled]="!hasUnsavedChanges() || hasValidationErrors()"
            >
              <i class="fa fa-users"></i>
              @if (hasUnsavedChanges()) { Save Assignments ({{ dirtyCount() }})
              } @else { Assign to Players }
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Purse Breakdown Grid -->
    <div class="col-lg-9">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Purse Breakdown Details</h5>
          <div class="ibox-tools">
            <label class="label label-primary"
              >{{ purseSettings().placesToPay }} Positions</label
            >
          </div>
        </div>
        <div class="ibox-content">
          @if (isLoading()) {
          <div class="sk-spinner sk-spinner-wave">
            <div class="sk-rect1"></div>
            <div class="sk-rect2"></div>
            <div class="sk-rect3"></div>
            <div class="sk-rect4"></div>
            <div class="sk-rect5"></div>
          </div>
          }

          <div class="table-responsive" [class.dimmed]="isLoading()">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th width="60" class="text-center">Pos</th>
                  <th width="60" class="text-center">Status</th>
                  <th>Player Name</th>
                  <th width="100" class="text-center">Percentage</th>
                  <th width="120" class="text-right">Projected</th>
                  <th width="120" class="text-right">Assigned</th>
                  <th width="80" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                @for (breakdown of paginatedBreakdowns(); track
                breakdown.playerId) {
                <tr [class.warning]="breakdown.isDirty">
                  <td class="text-center">
                    <span
                      class="label"
                      [ngClass]="getPositionClass(breakdown.position)"
                      >{{ breakdown.position }}</span
                    >
                  </td>
                  <td class="text-center">
                    <span
                      class="player-status"
                      [ngClass]="
                        breakdown.status === 'PRO'
                          ? 'status-pro'
                          : 'status-amateur'
                      "
                    >
                      {{ breakdown.status }}
                    </span>
                  </td>
                  <td>
                    <strong>{{ breakdown.playerName }}</strong>
                    @if (breakdown.status === 'AM') {
                    <i
                      class="fa fa-info-circle text-warning"
                      title="Amateur - No prize money"
                    ></i>
                    } @if (breakdown.isDirty) {
                    <i class="fa fa-pencil text-info" title="Modified"></i>
                    }
                  </td>
                  <td class="text-center">
                    <span class="text-muted"
                      >{{ breakdown.percentage.toFixed(2) }}%</span
                    >
                  </td>
                  <td class="text-right font-bold">
                    {{ formatCurrencyDetailed(breakdown.projected) }}
                  </td>
                  <td [class]="getVarianceClass(breakdown)">
                    <input
                      type="text"
                      class="form-control input-sm amount-input pull-right"
                      [value]="formatCurrency(breakdown.assigned)"
                      (input)="
                        onAssignmentChange(breakdown, $any($event.target).value)
                      "
                      (blur)="onAssignmentBlur(breakdown)"
                      [disabled]="breakdown.status === 'AM'"
                      [class.input-error]="breakdown.validationError"
                      name="assigned_{{ breakdown.playerId }}"
                      title="{{ breakdown.validationError || '' }}"
                    />
                    @if (breakdown.validationError) {
                    <small class="text-danger">{{
                      breakdown.validationError
                    }}</small>
                    }
                  </td>
                  <td class="text-center">
                    @if (breakdown.status === 'AM') {
                    <button
                      type="button"
                      class="btn btn-default btn-xs"
                      disabled
                      title="Amateur players cannot receive prize money"
                    >
                      <i class="fa fa-ban"></i> Save
                    </button>
                    } @else if (breakdown.isDirty && !breakdown.validationError)
                    {
                    <button
                      type="button"
                      class="btn btn-primary btn-xs"
                      (click)="onSaveIndividualAssignment(breakdown)"
                      title="Save this assignment"
                    >
                      <i class="fa fa-save"></i> Save
                    </button>
                    } @else if (breakdown.validationError) {
                    <button
                      type="button"
                      class="btn btn-danger btn-xs"
                      disabled
                      [title]="breakdown.validationError"
                    >
                      <i class="fa fa-exclamation"></i> Save
                    </button>
                    } @else {
                    <button
                      type="button"
                      class="btn btn-default btn-xs"
                      disabled
                      title="No changes to save"
                    >
                      <i class="fa fa-check"></i> Ok
                    </button>
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="text-center">
            <ul class="pagination">
              <li [class.disabled]="currentPage() === 1">
                <a
                  href="#"
                  (click)="
                    onPageChange(currentPage() - 1); $event.preventDefault()
                  "
                  >&laquo;</a
                >
              </li>
              @for (page of [].constructor(totalPages()); track $index) {
              <li [class.active]="$index + 1 === currentPage()">
                <a
                  href="#"
                  (click)="onPageChange($index + 1); $event.preventDefault()"
                  >{{ $index + 1 }}</a
                >
              </li>
              }
              <li [class.disabled]="currentPage() === totalPages()">
                <a
                  href="#"
                  (click)="
                    onPageChange(currentPage() + 1); $event.preventDefault()
                  "
                  >&raquo;</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="row">
            <div class="col-sm-4">
              <strong>Total Projected Payout:</strong>
              <span class="text-navy">{{
                formatCurrencyDetailed(totalProjected())
              }}</span>
            </div>
            <div class="col-sm-4">
              <strong>Total Assigned Payout:</strong>
              <span class="text-success">{{
                formatCurrencyDetailed(totalAssigned())
              }}</span>
            </div>
            <div class="col-sm-4 text-right">
              <strong>Variance:</strong>
              <span
                [ngClass]="variance() >= 0 ? 'text-danger' : 'text-success'"
              >
                {{ variance() >= 0 ? "+" : ""
                }}{{ formatCurrencyDetailed(variance()) }}
              </span>
              @if (variance() !== 0) {
              <i
                class="fa fa-warning text-warning"
                title="Assigned amount differs from projected"
              ></i>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Action Buttons Row -->
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content">
          <div class="text-center">
            <a
              routerLink="/tournaments/{{ tournamentId() }}"
              class="btn btn-white"
              [class.disabled]="isSaving()"
            >
              <i class="fa fa-times"></i> Cancel
            </a>
            <button
              type="button"
              class="btn btn-primary m-l-sm"
              (click)="onSaveDraft()"
              [disabled]="isSaving() || isLoading()"
            >
              @if (isSaving()) {
              <i class="fa fa-spinner fa-spin"></i> Saving... } @else {
              <i class="fa fa-save"></i> Save Draft }
            </button>
            <button
              type="button"
              class="btn btn-success m-l-sm"
              (click)="onFinalize()"
              [disabled]="isSaving() || isLoading()"
            >
              <i class="fa fa-check"></i> Finalize & Publish
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
